<template>
  <div class="layout">
    <vue-header/>
    <nuxt class="layout__inner"/>
    <vue-footer/>
  </div>
</template>

<script>
import VueHeader from '~/components/layout/header';
import VueFooter from '~/components/layout/footer';
import { ENVIRONMENT } from '~/utils/consts';

export default {
  name: 'DefaultLayout',
  components: { VueHeader, VueFooter },
  data() {
    return {
      isClaritySet: false,
    };
  },
  computed: {
    userId() {
      return this.$auth.user.id;
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId && process.client) {
          const clarity = window.clarity || null;
          if (clarity && !this.isClaritySet) {
            this.isClaritySet = true;
            clarity('set', 'userId', userId.toString());
          }
        }
      },
    },
  },
  mounted() {
    if (process.env.NODE_ENV !== ENVIRONMENT.DEVELOPMENT) {
      this.$chat24.init();
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__inner {
    flex-grow: 1;
  }

  & /deep/ .sidebar__toggle {
    background: map-get($colors, secondary);
    bottom: 84px;
    right: 13px;
  }

  @include mobile {
    /deep/ .sidebar__title {
      background: map-get($colors, secondary);
    }
  }
}
</style>
